import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "gatsby";

export default function MetricCard({ icon, title, subtitle, background, href, span }) {
  return (
    <div className={span ? "uk-width-1-1" : "uk-width-1-2@s "}>
      <Link
        to={href}
        className="uk-card metric-card uk-card-small uk-card-body uk-flex uk-flex-middle uk-margin-small-bottom uk-border-rounded metric-hero"
        style={{ backgroundColor: background, textDecoration: "none" }}
      >
        <div style={{ width: 50 }}>
          <FontAwesomeIcon icon={icon} size="3x" style={{ color: "#fff" }} />
        </div>
        <div className="uk-margin-left">
          <h3 style={{ color: "white" }} className="uk-margin-remove">
            {title}
          </h3>
          <p style={{ color: "white" }} className="uk-text-normal uk-margin-remove">
            {subtitle}
          </p>
        </div>
      </Link>
    </div>
  );
}
